module.exports = __webpack_public_path__ + "static/media/vc-logo-black-horizontal.b4e6df36.svg";